import axios from 'axios'
import qs from 'qs'

const prefix = `https://m.xinli001.com/`
const prefixMse = `https://mse.xinli001.com/`

export const qingsuTopic = id => axios.get(`${prefix}qingsu/topic-list/${id}`)

export const qingsuIndex = params => {
  return axios.get(`${prefix}new-qingsu/new-index`, { params })
}

export const qingsuIndexQingting = params => {
  return axios.get(`${prefix}new-qingsu/index/qingting`, {
    params,
    disabledUnLoginInterceptors: true
  })
}

export const qingsuTeacherList = (
  params = {
    sort: 'default',
    gender: 0,
    category: 0,
    page: 1,
    cid: '',
    recommended_ids: ''
  }
) => axios.post(`${prefix}new-qingsu/qingting-list`, qs.stringify(params))

// 倾诉首页列表接口
export const qingsuIndexTeacherList = (
  params = {
    sort: 'default',
    gender: 0,
    category: 0,
    page: 1,
    cid: '',
    recommended_ids: ''
  }
) => axios.post(`${prefix}qingsu/qingting_list`, qs.stringify(params))

// 倾诉首页列表接口V4
export const qingsuIndexTeacherListV4 = params =>
  axios.get(`${prefixMse}qingsu/api/confide/index/teacher/list`, { params })

// 倾诉用户信息接口
export const qingsuUserOwnInfo = params =>
  axios.get(`${prefixMse}qingsu/api/confide/index/teacher/ownInfo`, { params })

export const textQingsuTeacherList = (
  params = {
    sort: 'default',
    gender: 0,
    category: 0,
    page: 1,
    cid: ''
  }
) => axios.get(`${prefix}consultation/teacher-list`, { params })

export const qingsuVoice = vid =>
  axios.get(`${prefix}new-qingsu/qingting-voice?vid=${vid}`)

export const qingsuCheckOnline = params =>
  axios.get(`${prefix}new-qingsu/check-onlinelist`, { params })

export const qingsuChangeStatus = params =>
  axios.get(`${prefix}new-qingsu/change-status`, { params })

export const qingsuToggleStatus = data =>
  axios.post(`${prefixMse}qingsu/api/consult/teacher/status/toggle`, data)

export const qingsuMyOrder = cid =>
  axios.get(`${prefix}new-qingsu/myOrder?cid=${cid}`)

export const qingsuMood = () =>
  axios.get(`${prefix}new-qingsu/activity/my_mood`)

export const qingsuCheckRateStatus = (params = {}) =>
  axios.get(`${prefix}new-qingsu/checkRateStatus`, { params })

export const qingsuCheckstatus = (params = {}) =>
  axios.get(`${prefix}new-qingsu/checkstatus`, { params })

export const qingsuRemark = (data = {}) =>
  axios.post(`${prefix}new-qingsu/qingsuRemark`, data)

export const qingsuRate = data =>
  axios.post(`${prefix}new-qingsu/qingsuRate`, qs.stringify(data))

export const qingsuComplete = params =>
  axios.get(`${prefix}new-qingsu/qingsuComplete`, { params })

export const qingsuRefund = data =>
  axios.post(`${prefix}new-qingsu/refund`, data)

export const qingsuOrderCount = () =>
  axios.get(`${prefix}new-qingsu/orderCount`)

export const qingsuTimeout = id =>
  axios.get(`${prefix}new-qingsu/timeout?id=${id}`)

// 异步授权登录
export const qingsuWxOauth = params =>
  axios.get(`${prefix}new-qingsu/wx_oauth`, {
    params
  })

export const qingsuUserMessage = params =>
  axios.get(`${prefix}new-qingsu/user-info`, { params })

// 获取广告位数据
export const getAdLists = params => {
  return axios.get(prefixMse + `zixun/api/home/ad/list`, { params })
}

//外部渠道
// export const channnelPage = params => {
//   return axios.get(prefix + `new-qingsu/channel-page`, { params })
// }

//外部渠道广告
export const channnelAds = params => {
  return axios.get(prefix + `new-qingsu/channel-ads`, { params })
}

// 获取渠道信息
export const channelInfo = params => {
  return axios.get(prefix + `webzixun/channel-info`, { params })
}

// 获取57渠道动态数据
export const channelDynamic = () => {
  return axios.get(prefix + `new-qingsu/channel/dynamic`)
}

// 获取57渠道动态数据
export const channelRank = params => {
  return axios.get(prefix + `new-qingsu/activity/insurance/channel_rank`, {
    params
  })
}

// 获取已设置的倾听师上线提醒
export const fetchRemnders = (params = {}) =>
  axios.get(`${prefix}new-qingsu/get-user-online-reminder`, {
    params
  })

// 设置倾听师上线提醒
export const qingsuRemnder = data =>
  axios.post(`${prefix}new-qingsu/set-online-reminder`, data)

// 倾听师是否签署协议
export const qingsuSignAgreement = data =>
  axios.get(`${prefix}qingting/status`, data)

// 是否倾诉新用户

export const isQsBusinessNewUser = params => {
  return axios.get(`${prefix}new-qingsu/isBusinessNewUser`, {
    params
  })
}

// 新人专享福利
export const newcomerWelfare = params => {
  return axios.get(`${prefix}new-qingsu/newcomer-welfare`, { params })
}

/**
 * 用户心声数据
 * @param {String} https://yapi.xinli001.com/project/22/interface/api/20578
 */
export const thankrate = params => {
  return axios.get(`${prefix}new-qingsu/thankrate`, {
    params
  })
}
// 活动未绑定老师列表
export const unboundTeacher = params => {
  return axios.get(`${prefix}consult_activity/2022/mhd/unbound_teacher_list`, {
    params
  })
}

// 发送私信
export const sendLetter = params => {
  return axios.get(
    `${prefix}consult_activity/2022/mhd/send_service_start_letter`,
    {
      params
    }
  )
}

// 未读im信息
export const unreadMessageCount = params => {
  return axios.get(`${prefix}qingting/im_reply/unread_message_count`, {
    params
  })
}

// 邀请老师上线
export const inviteQingtingOnline = params => {
  return axios.post(`${prefix}qingsu_index/invite_qingting_online`, params)
}

// 随机在线倾听师
export const randomOnlineList = params => {
  return axios.get(`${prefix}qingsu_index/random_online_list`, {
    params
  })
}

// 推荐老师
export const recommendList = params => {
  return axios.get(`${prefix}qingsu_index/recommend_list`, {
    params
  })
}

// 触发老师自动回复
export const systemReply = params => {
  return axios.get(`${prefix}qingting/im_reply/system_reply`, {
    params
  })
}

// 倾诉合作渠道倾诉次数
export const getChannelCount = params =>
  axios.get(`${prefix}new-qingsu/get-channel-count`, { params })

// 外部渠道剩余名额及优惠券
export const channelCoupon = params => {
  return axios.get(`${prefix}new-qingsu/cooperation/quota-coupon`, { params })
}

// 倾诉部分渠道用加密手机号登录
export const loginWithAuthKey = params =>
  axios.get(`${prefix}qingsu_channel/auth_phone_login`, { params })

// 倾诉B端渠道用户鉴权
export const businessUserCheck = params =>
  axios.get(`${prefix}qingsu_channel/business_channel/user_check`, { params })

// 推荐倾诉师
export const recommendQingsu = params =>
  axios.get(`${prefix}new-qingsu/recommend-qingting`, { params })

// 是否新来访
export const newVisit = params =>
  axios.get(`${prefix}new-qingsu/user-visit`, { params })

// 基础资料
export const getBasicInfo = params =>
  axios.get(`${prefix}user_home/basic`, { params })

// -------- 倾诉有礼 --------
// 礼包信息
export const getInvitePkgInfo = params =>
  axios.get(`${prefix}qingsu_activity/2023/invite/pkg_info`, { params })

// 领取礼包
export const receiveInvitePkgApi = params => {
  return axios.post(
    `${prefix}qingsu_activity/2023/invite/receive_invite_pkg`,
    params
  )
}

// 倾诉邀请排行榜
export const rankListApi = () =>
  axios.get(`${prefix}qingsu_activity/2023/invite/rank`)

// 倾诉邀请有礼 领取五元优惠券
export const inviteReceiveCoupon = () =>
  axios.get(`${prefix}qingsu_activity/2023/invite/get_activity_coupon`)

// 绑定用户
export const bindInviteUser = params => {
  return axios.post(`${prefix}qingsu_activity/2023/invite/bind_invite`, params)
}

// 绑定列表
export const getInviteUserList = params =>
  axios.get(`${prefix}qingsu_activity/2023/invite/my_invite`, { params })

// 弹幕接口
export const getBarrageData = () =>
  axios.get(`${prefix}/qingsu_activity/2023/invite/barrage`)
// -------- 倾诉有礼 --------

// 倾听师自己
export const homeQingtingInfo = () =>
  axios.get(`${prefix}qingsu/home_qingting_info`)

export const getTingStatus = () =>
  axios.get(`${prefix}qingsu/qingting_list_status`)

// 倾听师自动回复
export const autoReply = params =>
  axios.get(`${prefix}qingting/im_reply/auto_reply`, { params })

// 新人专享活动福利
export const newUserCouponData = params =>
  axios.get(`${prefix}new-qingsu/newcomer-activity`, { params })

// 领取新人专享活动福利
export const receiveNewUserCoupon = params =>
  axios.post(`${prefix}new-qingsu/receive-newcomer-activity`, params)

// 获取销售二维码
export const getQinTingQrcodeLink = params =>
  axios.get(`https://api-college.xinli001.com/campPro/service/get`, {
    params: Object.assign(
      {
        type: 'qingting'
      },
      params
    )
  })

// 新版文字倾诉
export const newQingSuList = params =>
  axios.get(`${prefix}qingsu-text/teacher_list`, { params })

// 双十一：红包雨抽奖场次
export const getRedenvInfo = () =>
  axios.get(`${prefix}qingsu_activity/2023/double_eleven/activity_info`)

// 双十一：领取优惠劵
export const receiveRedenv = params => {
  return axios.post(
    `${prefix}qingsu_activity/2023/double_eleven/coupon_receive`,
    params
  )
}

// 邀请有礼4.0
export const getQingsuActivity = params =>
  axios.get(`${prefix}qingsu_activity/2023/invite/coupon_data`, { params })

// 邀请有礼4.0礼包列表
export const getFreeGifts = params =>
  axios.get(`${prefix}qingsu_activity/2023/invite/free_gifts`, { params })

// 倾听小记详情
export const getQSFeedbackDetail = params =>
  axios.get(`${prefixMse}user/api/app/confide/feedbackLog`, { params })

// 保存倾述反馈报告
export const saveQSFeedback = params => {
  return axios.post(
    `${prefixMse}qingsu/api/confide/feedback/log/saveOrUpdate`,
    params
  )
}
// 发送倾述反馈报告
export const sendQSFeedback = params =>
  axios.get(`${prefix}/qingsu/send_feedback`, { params })
// 春节活动信息
export const getSpringInfo = params =>
  axios.get(`${prefix}qingsu_activity/2024/spring/activity_info`, { params })

// 春节红包雨
export const springDraw = params =>
  axios.post(`${prefix}qingsu_activity/2024/spring/activity_draw`, params)

// 倾听师祝福语
export const getBlessings = params =>
  axios.get(`${prefix}qingsu_activity/2024/spring/blessings`, { params })

// 套餐活动详情
export const getQingsuActivityInfo = params =>
  axios.get(`${prefix}/qingsu_package/activity_info`, { params })
